<template>
  <section id="lgpd-identity-verification">
    <p>
      {{ $t('components.lgpd_identity_verification.instructions') }}
    </p>
    <div id="lgpd-identity-verification-fields">
      <brazil-text-field
        v-model="full_name"
        name="name"
        input-id="user_full_name"
        :label="$t('components.lgpd_identity_verification.full_name_label')"
        autocomplete="name"
        :validator-field="validatorField.full_name"
      />
      <brazil-text-field
        v-model="date_of_birth"
        name="bday"
        input-id="user_date_of_birth"
        type="tel"
        :label="$t('components.lgpd_identity_verification.date_of_birth_label')"
        autocomplete="bday"
        placeholder="dd/mm/aaaa"
        :mask="dateMask"
        maxlength="10"
        :validator-field="validatorField.date_of_birth"
      />
      <brazil-text-field
        v-model="cpf"
        name="cpf"
        input-id="user_cpf"
        type="tel"
        :label="$t('components.lgpd_identity_verification.cpf_label')"
        autocomplete="cpf"
        placeholder="___.___.___-__"
        :mask="cpfMask"
        maxlength="14"
        :validator-field="validatorField.cpf"
      />
      <brazil-text-field
        v-model="mother_name"
        name="mother_name"
        input-id="user_mother_name"
        :label="$t('components.lgpd_identity_verification.mothers_name_label')"
        :validator-field="validatorField.mother_name"
      />
    </div>
    <span
      id="required-field-label"
      v-html="$t('components.lgpd_identity_verification.required_field_label')"
    />
  </section>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import {
  moreThanOneWord,
  internationalDate,
  minimumAge,
  cpf,
} from '../validators';
import BrazilTextField from './fields/BrazilTextField.vue';
import { cpfMask, dateMask } from '../config/masks';

export default {
  components: { BrazilTextField },
  props:      {
    value: {
      type:     Object,
      required: true,
    },
    validatorField: {
      type:     Object,
      required: true,
    },
  },
  data() {
    return {
      dateMask,
      cpfMask,
    };
  },
  computed: {
    full_name: {
      get() {
        return this.value.full_name;
      },
      set(val) {
        this.$emit('input', { ...this.value, full_name: val });
      },
    },
    date_of_birth: {
      get() {
        return this.value.date_of_birth;
      },
      set(val) {
        this.$emit('input', { ...this.value, date_of_birth: val });
      },
    },
    cpf: {
      get() {
        return this.value.cpf;
      },
      set(val) {
        this.$emit('input', { ...this.value, cpf: val });
      },
    },
    mother_name: {
      get() {
        return this.value.mother_name;
      },
      set(val) {
        this.$emit('input', { ...this.value, mother_name: val });
      },
    },
  },
};

export const lgpdIdentityVerificationDefaultValues = {
  full_name:     '',
  date_of_birth: '',
  cpf:           '',
  mother_name:   '',
};

export const lgpdIdentityVerificationValidator = {
  full_name: {
    required,
    moreThanOneWord,
  },
  date_of_birth: {
    required,
    internationalDate,
    minimumAge,
  },
  cpf: {
    required,
    cpf,
  },
  mother_name: {
    required,
  },
};
</script>
<style lang="scss" scoped>
  #lgpd-identity-verification {
    margin-bottom: 1rem;
  }
  #lgpd-identity-verification-fields {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  #required-field-label {
    font-size: 0.8rem;
  }
</style>
